import React, { Suspense } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Button, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import Wrapper from '~/App/components/Wrapper';
import Header from '~/App/components/Header';
import { useNavigate } from 'react-router-dom';
import ErrorBoundary from '~/App/components/ErrorBoundary';
import Loading from '~/App/components/Loading';
import api from '../../api';
import { UserItem } from '../../types';
import { CheckCircleOutlined } from '@ant-design/icons';

const ListUserTable = () => {
  const { data } = useSuspenseQuery({
    queryKey: ['fetchUsers'],
    queryFn: () => {
      return api.getUsers().then(({ users }) => users);
    },
  });
  const navigate = useNavigate();

  const columns: ColumnsType<UserItem> = [
    {
      title: 'Name',
      dataIndex: 'name',
    },
    {
      title: 'Username',
      dataIndex: 'username',
    },
    {
      title: 'Internal',
      dataIndex: 'isInternal',
      render: (col: UserItem['isInternal']) => {
        return col ? <CheckCircleOutlined /> : null;
      },
    },
    {
      title: 'Action',
      render: (_, item) => {
        return (
          <div className="flex gap-2">
            <Button
              type="primary"
              onClick={() => navigate(`edit/${item.userId}`)}
            >
              Edit
            </Button>
            <Button onClick={() => navigate(`edit-pin/${item.userId}`)}>
              Change PIN
            </Button>
          </div>
        );
      },
    },
  ];

  return (
    <Table dataSource={data} columns={columns} rowKey={(item) => item.userId} />
  );
};

const ListUser = () => {
  const navigate = useNavigate();
  return (
    <Wrapper>
      <div className="flex justify-between">
        <Header title="User List" />
        <Button type="primary" onClick={() => navigate('create')}>
          + Create
        </Button>
      </div>
      <ErrorBoundary>
        <Suspense fallback={<Loading className="h-[400px]" />}>
          <ListUserTable />
        </Suspense>
      </ErrorBoundary>
    </Wrapper>
  );
};

export default ListUser;
